import { formatDate, valueGetter } from '../utils/commonUtils';

export const PERMISSIONS_PAGE = {
  ACTIVE_PERMISSIONS: 'Active Permissions',
  INACTIVE_PERMISSIONS: 'Inactive Permissions',
  CANCEL_PERMISSION: 'Cancel Permission',
  NO_ACTIVE_PERMISSIONS: {
    P1: 'Active permissions will be shown here',
    P2: 'No active permissions',
  },
  NO_INACTIVE_PERMISSIONS: {
    P1: 'Inactive Permissions will be shown here',
  },
};

export const PERMISSIONS_COLUMNS = {
  ACTIVE_PERMISSIONS_COLUMNS: [
    { header: 'Reference', key: 'bank_reference' },
    {
      header: 'Start Date',
      key: 'vrp_setup_date',
      formatDate: (row) => formatDate(row.vrp_setup_date),
    },
    {
      header: 'End Date',
      key: 'vrp_end_date',
      formatDate: (row) => formatDate(row.vrp_end_date),
    },
    { header: 'Individual Payment Limit', key: 'individual_maximum_amount' },
    { header: 'Daily Payment Limit', key: 'periodic_maximum_amount' },
    { header: 'Bank', key: 'customer_bank_name' },
    { header: 'Account Type', key: '' },
    {
      header: 'Account Details',
      key: 'account_details',
      valueGetter: (row) => valueGetter(row.customer_sortcode, row.customer_account_number),
    },
  ],
  INACTIVE_PERMISSIONS_COLUMNS: [
    { header: 'Status', key: 'status' },
  ],
};

export const SHOW_PWBT = {
  CREATE_BTN: 'Create Permission',
  EDIT_BTN: 'Edit Details',
};
